import React from "react";

export default function statusTerugNaarOverzicht(color){
	return (<svg id="Laag_2" viewBox="-5 -7 65 65" width="65px" height="65px">
		<g>
			<path fill={color} d="M36.226,8.466h-5.119H19.894h-5.12c-1.237,0-2.241,1.005-2.241,2.241v29.586
				c0,1.237,1.004,2.241,2.241,2.241h21.452c1.236,0,2.242-1.004,2.242-2.241V10.707C38.468,9.471,37.462,8.466,36.226,8.466
				M30.21,13.604h-9.42V9.362h9.42V13.604z M31.106,14.5v-1.931h3.467v25.862H16.425V12.569h3.469V14.5H31.106z M37.571,40.293
				c0,0.742-0.604,1.346-1.346,1.346H14.774c-0.741,0-1.345-0.604-1.345-1.346V10.707c0-0.741,0.604-1.345,1.345-1.345h5.12v2.311
				H15.53v27.655h19.94V11.673h-4.363V9.362h5.119c0.742,0,1.346,0.604,1.346,1.345V40.293z"/>
			<path fill={color} d="M17.839,19.123c0,1.699,1.383,3.082,3.081,3.082c1.7,0,3.082-1.383,3.082-3.082s-1.382-3.082-3.082-3.082
				C19.222,16.041,17.839,17.424,17.839,19.123 M20.92,16.938c0.468,0,0.901,0.172,1.254,0.401c0.29,0.188,0.412,0.342,0.622,0.683
				c0.21,0.34,0.31,0.698,0.31,1.102c0,1.205-0.98,2.186-2.186,2.186s-2.185-0.98-2.185-2.186S19.715,16.938,20.92,16.938"/>
			<path fill={color} d="M20.92,23.492c-1.698,0-3.081,1.383-3.081,3.082c0,1.7,1.383,3.082,3.081,3.082
				c1.7,0,3.082-1.382,3.082-3.082C24.002,24.875,22.621,23.492,20.92,23.492 M20.92,28.759c-1.205,0-2.185-0.979-2.185-2.185
				s0.979-2.186,2.185-2.186c0.468,0,0.984,0.205,1.254,0.4s0.414,0.381,0.623,0.684s0.309,0.697,0.309,1.102
				C23.106,27.779,22.125,28.759,20.92,28.759"/>
			<path fill={color} d="M20.92,30.943c-1.698,0-3.081,1.383-3.081,3.082s1.383,3.08,3.081,3.08c1.7,0,3.082-1.381,3.082-3.08
				S22.621,30.943,20.92,30.943 M20.92,36.21c-1.205,0-2.185-0.98-2.185-2.185c0-1.205,0.979-2.186,2.185-2.186
				c0.468,0,1.007,0.221,1.255,0.4s0.455,0.416,0.622,0.684s0.309,0.697,0.309,1.102C23.106,35.229,22.125,36.21,20.92,36.21"/>
			<rect x="25.257" y="17.649" fill={color} width="1.621" height="0.897"/>
			<rect x="25.257" y="19.7" fill={color} width="7.24" height="0.896"/>
			<rect x="25.257" y="25.102" fill={color} width="1.621" height="0.896"/>
			<rect x="25.257" y="27.151" fill={color} width="7.24" height="0.896"/>
			<rect x="25.257" y="32.551" fill={color} width="1.621" height="0.897"/>
			<rect x="25.257" y="34.603" fill={color} width="7.24" height="0.896"/>
		</g>
	</svg>);
}